import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import BlockHeaderCenter from 'components/common/BlockHeaderCenter';

import imgFearturePhoto1PC1x from 'assets/images/PC/@1x/img_feature_photo1.png';
import imgFearturePhoto1PC2x from 'assets/images/PC/@2x/img_feature_photo1@2x.jpg';
import imgFearturePhoto1SP2x from 'assets/images/SP/@2x/img_feature_photo1@2x.jpg';
import imgFearturePhoto1SP3x from 'assets/images/SP/@3x/img_feature_photo1@3x.jpg';
import imgFearturePhoto1WebpPC1x from 'assets/images/PC/@1x/img_feature_photo1.webp';
import imgFearturePhoto1WebpPC2x from 'assets/images/PC/@2x/img_feature_photo1@2x.webp';
import imgFearturePhoto1WebpSP2x from 'assets/images/SP/@2x/img_feature_photo1@2x.webp';
import imgFearturePhoto1WebpSP3x from 'assets/images/SP/@3x/img_feature_photo1@3x.webp';

import imgFearturePhoto2PC1x from 'assets/images/PC/@1x/img_feature_photo2.png';
import imgFearturePhoto2PC2x from 'assets/images/PC/@2x/img_feature_photo2@2x.jpg';
import imgFearturePhoto2SP2x from 'assets/images/SP/@2x/img_feature_photo2@2x.jpg';
import imgFearturePhoto2SP3x from 'assets/images/SP/@3x/img_feature_photo2@3x.jpg';
import imgFearturePhoto2WebpPC1x from 'assets/images/PC/@1x/img_feature_photo2.webp';
import imgFearturePhoto2WebpPC2x from 'assets/images/PC/@2x/img_feature_photo2@2x.webp';
import imgFearturePhoto2WebpSP2x from 'assets/images/SP/@2x/img_feature_photo2@2x.webp';
import imgFearturePhoto2WebpSP3x from 'assets/images/SP/@3x/img_feature_photo2@3x.webp';

import imgFearturePhoto3PC1x from 'assets/images/PC/@1x/img_feature_photo3.png';
import imgFearturePhoto3PC2x from 'assets/images/PC/@2x/img_feature_photo3@2x.png';
import imgFearturePhoto3SP2x from 'assets/images/SP/@2x/img_feature_photo3@2x.png';
import imgFearturePhoto3SP3x from 'assets/images/SP/@3x/img_feature_photo3@3x.png';

const features = [
  <div className="feature">
    <Image
      pc1x={imgFearturePhoto1PC1x}
      pc2x={imgFearturePhoto1PC2x}
      sp2x={imgFearturePhoto1SP2x}
      sp3x={imgFearturePhoto1SP3x}
      webpPC1x={imgFearturePhoto1WebpPC1x}
      webpPC2x={imgFearturePhoto1WebpPC2x}
      webpSP2x={imgFearturePhoto1WebpSP2x}
      webpSP3x={imgFearturePhoto1WebpSP3x}
      alt="img_fearture_photo1"
    />
    <div>
      <p className="point">Point.1</p>
      <h4>
        全国にある星野リゾートの宿で
        <br />
        1年間いつでもご利用可能です。
      </h4>
      <p className="description">
        ご利用人数・お部屋数・ご宿泊数・プランはご宿泊者が自由に選択可能です。
      </p>
      <div className="tips">
        <p>額面以上のお支払いはご宿泊者のご精算となります。</p>
        <p>
          本ギフト券の有効期間はご購入時にご指定いただいた日付から1年間となります。
        </p>
      </div>
    </div>
  </div>,
  <div className="feature">
    <Image
      pc1x={imgFearturePhoto2PC1x}
      pc2x={imgFearturePhoto2PC2x}
      sp2x={imgFearturePhoto2SP2x}
      sp3x={imgFearturePhoto2SP3x}
      webpPC1x={imgFearturePhoto2WebpPC1x}
      webpPC2x={imgFearturePhoto2WebpPC2x}
      webpSP2x={imgFearturePhoto2WebpSP2x}
      webpSP3x={imgFearturePhoto2WebpSP3x}
      alt="img_fearture_photo2"
    />
    <div>
      <p className="point">Point.2</p>
      <h4 className="pcStyle">
        オリジナル封筒に熨斗紙、メッセージカードを
        <br />
        付けてお届けいたします。
      </h4>
      <h4 className="spStyle">
        オリジナル封筒に熨斗紙、メッセージカードを付けてお届けいたします。
      </h4>
      <p className="description">
        お祝いや感謝の気持ちを伝える等、用途に合わせてご利用いただけます。
      </p>
      <div className="tips">
        <p className="pcStyle">
          1ヶ所のお相手に対して複数枚のギフト券をご注文いただく場合は
          <br />
          封筒1枚にまとめて封入いたします。
        </p>
        <p className="spStyle">
          1ヶ所のお相手に対して複数枚のギフト券をご注文いただく場合は封筒1枚にまとめて封入いたします。
        </p>
      </div>
    </div>
  </div>,
  <div className="feature">
    <Image
      pc1x={imgFearturePhoto3PC1x}
      pc2x={imgFearturePhoto3PC2x}
      sp2x={imgFearturePhoto3SP2x}
      sp3x={imgFearturePhoto3SP3x}
      alt="img_fearture_photo3"
    />
    <div>
      <p className="point">Point.3</p>
      <h4 className="pcStyle">
        お支払いはクレジットカードまたは銀行振込で
        <br />
        ご購入可能です。
      </h4>
      <h4 className="spStyle">
        お支払いはクレジットカードまたは銀行振込でご購入可能です。
      </h4>
      <div className="description">
        <p>本サイト上で見積書・領収書を発行できます。</p>
        <p>請求書は銀行振込でご購入の方のみメールにてお送りいたします。</p>
      </div>
    </div>
  </div>
];

const Feature = ({ className }) => (
  <div className={className}>
    <BlockHeaderCenter>宿泊ギフト券の特徴</BlockHeaderCenter>
    <ul>
      {features.map((feature, i) => {
        return <li key={i}>{feature}</li>;
      })}
    </ul>
  </div>
);

const commonStyle = css`
  ul {
    margin: 0;
    padding: 0;

    li {
      list-style: none;
    }
    .feature {
      > picture {
        margin-right: 56px;
      }

      > div {
        max-width: 560px;
        width: 50%;

        .point {
          position: relative;
          color: ${Colors.orange1};
          ${FontStyles.text8};
          letter-spacing: 1px;
          display: inline-block;

          &:after {
            content: ' ';
            position: absolute;
            border: 0;
            border-top: solid 1px ${Colors.gray2};
            margin-left: 8px;
          }
        }

        h4 {
          margin: 0;
          color: ${Colors.black2};
          ${FontStyles.text4};
        }

        .description {
          color: ${Colors.black2};
          ${FontStyles.text8};

          p {
            margin: 0;
          }
        }

        .tips {
          > * {
            margin: 0;
            color: ${Colors.gray10};
            ${FontStyles.text10};
            padding-left: 20px;
            position: relative;

            &:before {
              content: '※';
              position: absolute;
              left: 0;
            }
          }
        }
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  margin: 0 80px;

  ${BlockHeaderCenter} {
    margin-top: 74px;
  }

  .pcStyle {
    display: run-in;
  }

  .spStyle {
    display: none;
  }

  ul {
    li {
      .feature {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        margin-bottom: 88px;

        > div {
          line-height: 1.0;

          h4 {
            margin-bottom: 14px;
          }
          .point {
            margin: 0 0 20px;
            line-height: 1.0;

            &:after {
              top: 8px;
              width: 16px;
            }

          }
          .description {
            margin: 0 0 22px;
          }
        }
      }


      &:last-of-type {
        .feature {
          margin-bottom: 96px;
        }
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  padding: 0 16px;

  .pcStyle {
    display: none;
  }

  .spStyle {
    display: run-in;
  }


  ${BlockHeaderCenter} {
    margin-bottom: 48px;
  }

  ul {
    li {
      .feature {
        display: block;
        margin-bottom: 40px;

        > picture {
          margin: 0;
          > img {
            width: 100%;
          }
        }

        > div {
          max-width: auto;
          width: auto;
          margin-top: 20px;

          .point {
            margin: 0 0 12px;

            &:after {
              top: 11px;
              width: 12px;
            }

          }

          h4 {
            margin: 0 0 8px;
          }

          .description {
            margin: 0 0 16px;
          }

          .tips {
            > * {
              ${FontStyles.text8};
            }
          }
        }
      }

      &:last-of-type {
        .feature {
          margin-bottom: 32px;
        }
      }
    }
  }
`;

export default applyStyles(Feature)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/Feature.js